module.exports = __webpack_public_path__ + "img/courses.fe5fc76d.svg";